import React from 'react';
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';

import { useIsAuthenticated } from '@azure/msal-react';

import Main from './Main';
import NotFound from './components/NotFound';
import Login from './containers/Login';
import Callback from './containers/Callback';
import Berichten from "./containers/pages/Berichten/Berichten";
import Dashboard from "./containers/pages/Dashboard";

const AppRouter = () => {
    const isAuthenticated = useIsAuthenticated();
    // Current path for login redirect
    const currentPath = window.location?.pathname;
    // Return URL for callback redirect
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const returnUrl = urlParams.get('returnUrl') ?? undefined;

    return (
        <Router>
            <Switch>
                <Route path="/login" render={() => (isAuthenticated ? <Redirect to={'/callback'}/> : <Login returnUrl={returnUrl}/>)}/>
                <Route path="/callback" component={Callback}/>
                <Route
                    render={() =>
                        isAuthenticated ? (
                                <Main>
                                    <Switch>
                                        <Route path="/" exact render={() => <Redirect to="/dashboard" />} />
                                        <Route path="/dashboard" exact component={Dashboard} />
                                        <Route path="/dico" exact component={Berichten}/>
                                        <Route path="/dico/:status" exact component={Berichten} />
                                        <Route component={NotFound}/>
                                    </Switch>
                                </Main>
                            ) :
                            (
                                <Redirect to={{pathname: `/login/?returnUrl=${encodeURIComponent(currentPath)}`}}/>
                            )
                    }
                />
            </Switch>
        </Router>
    );
};

export default AppRouter;
